<template>
    <div>
        <!-- <h6 class="heading-small text-muted mb-4">Order Items</h6> -->
        <b-overlay :show="loading" rounded="sm">
            <b-modal hide-footer v-model="isListItemModalVisible" no-close-on-backdrop size="sm" class="pt-8" centered
                header-class="p-0" @cancel="cancel"
                footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap"
                body-class="p-0">
                <template #modal-header>
                    <div class="title-block text-center p-2">
                        {{ $translate('products_of_interest') }}
                        <button class="close" @click="cancel">
                            x
                        </button>
                    </div>
                </template>
                <template #default>
                    <!-- <b-col cols="12" class=""> -->
                    <b-card>
                        <b-card-body  id="view-card-body" class="p-0 py-3">
                            <p v-if="itemModel.order"><strong>{{ $translate('activity') }}: </strong>{{ itemModel.order.reference_no }}</p>
                            <p v-if="itemModel.order?.crm_opportunity_type"><strong>{{ $translate('crm_opportunity_type') }}: </strong>{{ itemModel.order?.crm_opportunity_type?.name }}</p>
                            <!-- <b-button variant="info" @click="showItem(itemModel, {viewMode})">
                                {{ $translate('add_products_of_interest') }}
                            </b-button> -->
                            <b-table :fields="fields" :items="items">
                                <template #cell(id)="{item}">
                                    <b-button 
                                        :id="'view-product-of-interest-item-'+item.id"
                                        class="me-2 d-inline-block p-0"
                                        variant="pink-button"
                                        size="sm"
                                        @click="viewItem(item.id)"
                                    >
                                        <img
                                            src="@/assets/images/icon/view.svg"
                                            alt="View"
                                        />
                                    </b-button>
                                    <b-button
                                     :id="'delete-product-of-interest-item-'+item.id"
                                        class=" d-inline-block p-0"
                                        @click="deleteItem(item.id)"
                                        variant="pink-button"
                                        size="sm"
                                    >
                                        <img
                                            src="@/assets/images/icon/delete.svg"
                                            alt="Delete"
                                        />
                                    </b-button>
                                </template>
                            </b-table>
                        </b-card-body>
                    </b-card>
                </template>
            </b-modal>

            <b-modal hide-footer v-model="isViewItemModalVisible" no-close-on-backdrop size="sm" class="pt-8" centered
                header-class="p-0" @cancel="cancel"
                footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap"
                body-class="p-0">
                <template #modal-header>
                    <div class="title-block text-center p-2">
                        {{ !itemModel.id ? $translate('add_products_of_interest') : $translate('edit_products_of_interest')  }}
                        <button class="close" @click="cancel">
                            x
                        </button>
                    </div>
                </template>
                <template #default>
                    <!-- <b-col cols="12" class=""> -->
                    <b-card>
                        <b-card-body class="p-0 py-3">
                            <p v-if="itemModel.order"><strong>{{ $translate('activity') }}: </strong>{{ itemModel.order.reference_no }}</p>
                            <p v-if="itemModel.order?.crm_opportunity_type"><strong>{{ $translate('crm_opportunity_type') }}: </strong>{{ itemModel.order?.crm_opportunity_type?.name }}</p>
                            <b-form class="form-sample" @submit.stop.prevent="createOrUpdate">
                                


                                <b-row>
                                    <b-col cols="12" md="12" class="mt-3 dd">
                                        <label class="mb-3" for="input-order_item_type_id_poi"><strong>{{ $translate('item_type') }}
                                            </strong><span class="red"></span></label>
                                        <b-form-select class="form-control" id="input-order_item_type_id_poi"
                                            v-custom-validation="$selectRequired()" value-field="id" text-field="name"
                                            v-model="itemModel.order_item_type_id" :options="itemTypes">
                                            <template #first>
                                                <b-form-select-option :value="null">
                                                    {{ $translate('select_item_type') }}
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>

                                    <b-col cols="12" md="12" class="mt-3 dd">
                                        <label class="mb-3" for="input-master_items_poi"><strong>{{ $translate('items') }}
                                            </strong><span class="red"></span></label>
                                            <multiselect id="input-master_items_poi" :placeholder="$translate('select_items')" 
                                                class="master_items_poi"
                                                v-model="itemModel.master_items" 
                                                :options="masterItems" 
                                                :searchable="true"
                                                open-direction="bottom"
                                                :internal-search="false"
                                                @search-change="searchMasterItem"
                                                :clear-on-select="false" 
                                                :show-no-results="false" 
                                                :hide-selected="true"
                                                :multiple="true" 
                                                :preserve-search="true"
                                                :selectLabel="selectLabel" 
                                            
                                                label="name" track-by="id" :close-on-select="false">
                                                <template #clear="props">
                                                    <div class="multiselect__clear" 
                                                        v-if="itemModel.master_items && itemModel.master_items.length"
                                                        @mousedown.prevent.stop="clearAllMasterItems(props.search)">
                                                    </div>
                                                </template>
                                            </multiselect>
                                    </b-col>

                                    <b-col cols="12" md="12" class="mt-3 dd">
                                        <label class="mb-3" for="input-assets_poi"><strong>{{ $translate('assets') }}
                                            </strong><span class="red"></span></label>
                                            <multiselect id="input-assets_poi" :placeholder="$translate('select_items')" 
                                                class="assets_poi"
                                                v-model="itemModel.assets" 
                                                :options="assetOptions" 
                                                :searchable="true"
                                                open-direction="bottom"
                                                :internal-search="false"
                                                :loading="loading"
                                                @search-change="searchAsset"
                                                :clear-on-select="false" 
                                                :show-no-results="false" 
                                                :hide-selected="true"
                                                :multiple="true" 
                                                :preserve-search="true"
                                                :selectLabel="selectLabel" 
                                            
                                                label="name" track-by="id" :close-on-select="false">

                                                <template #clear="props">
                                                    <div class="multiselect__clear" 
                                                        v-if="itemModel.assets && itemModel.assets.length"
                                                        @mousedown.prevent.stop="clearAllAssets(props.search)">
                                                    </div>
                                                </template>
                                                
                                            </multiselect>
                                    </b-col>

                                    <b-col cols="12" md="12" class="mt-3">
                                        <label class="mb-3" for="input-notes_poi"><strong>{{ $translate('notes') }}
                                            </strong><span class="red"></span></label>
                                        <textarea v-model="itemModel.notes" id="input-notes_poi" rows="4" class="form-control w-100"></textarea>
                                    </b-col>
                                </b-row>
                                

                                <b-col md="12" class="mb-2 mt-3 text-center">
                                   
                                    <b-button id="create-item-of-interest-btn" v-if="!itemModel.id" type="submit" class="btn btn-info btn-fw me-2"
                                        variant="primary" :disabled="loading ? true : false">{{ createLabel
                                        }}</b-button>
                                    <b-button id="update-item-of-interest-btn" v-if="itemModel.id" type="submit" class="btn btn-info btn-fw me-2"
                                        variant="primary" :disabled="loading ? true : false">{{ updateLabel
                                        }}</b-button>
                                    <b-button id="delete-item-of-interest-btn" v-if="itemModel.id" @click="deleteItem(itemModel.id)" size="fw" class="me-2"
                                        variant="delete-button">
                                        {{ $deleteLabel() }}
                                    </b-button>
                                    <b-button id="cancel-item-of-interest-btn" variant="info" :disabled="loading ? true : false" @click="cancel()" class="btn-fw">
                                        {{ $cancelLabel() }}
                                    </b-button>
                                </b-col>

                            </b-form>
                        </b-card-body>
                    </b-card>
                </template>
            </b-modal>
        </b-overlay>
    </div>
</template>

<script>
// import EventBus from '@/exports/event-bus.js'
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'
import { buildQuery } from '../../exports/queryStringBuilder'

import Multiselect from 'vue-multiselect'
import axios from 'axios'

const defaultItemModel = Object.freeze({
    id: null,
    order: null,
    order_id: null,
    order_item_type_id: null,
    item_type: null,
    assets: [],
    master_items: [],
    notes: null,
})

export default {
    name: 'opportunity-products-of-interest-item',
    components: {  Multiselect },
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            isViewItemModalVisible: false,
            isListItemModalVisible: false,
            itemModel: {},
            loading: false,
            items: [],
            viewMode: false,
           
        }
    },
    props: { },
    filters: {
        currency: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        displayTypeName(id, types) {
            console.log('types', types)
            return (types.find(x => x.id == id) || {}).name
        },
        filterTypeName(value, types) {
            return (types.find(x => x.id == value) || {}).name
        },
    },

    computed: {
        
        fields() {
            return [
                { key: 'id', label: '' },
                { 
                    key: 'item_type', 
                    label: this.$translate('item_type'),
                    formatter: (value) => value?.name, 
                    tdClass: 'order-table-description',
                },
                { 
                    key: 'master_items', 
                    label: this.$translate('items'),
                    tdClass: 'order-table-description',
                    tdStyle: {width: '250px'},
                    formatter: (value) => value? value.map(x => x.name).join(', ') : '' 
                },
                { 
                    key: 'assets', 
                    label: this.$translate('assets'),
                    formatter: (value) => value ? value?.map(x => (x.name + (x.model_no ? ` - ${x.model_no}` : '') + (x.serial_no ? ` - ${x.serial_no}` : '') )).join(', ') : '',
                    tdClass: 'order-table-description',
                },
                { key: 'notes', label: this.$translate('notes') },
            ]
        },

        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.itemModel.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        
        itemTypes() {
            return this.$store.state.itemType.items;
        },

        masterItems() {
            return this.$store.state.masterItem.items;
        },

        assets() {
            return this.$store.state.assets.assets;
        },

        assetOptions() {
            let assets = this.assets || []
            if(this.itemModel.master_items.length > 0){
                assets = assets.filter(x => this.itemModel.master_items.some(m_i => m_i.id == x.master_item_id))
            }
            return assets.map(x => ({
                id: x.id,
                name: x.name + (x.model_no ? ` - ${x.model_no} ` : '') + (x.serial_no ? ` - ${x.serial_no} ` : ''),
            }));
        },
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
    },
    watch: {
        'itemModel.order_item_type_id': async function(val, oldVal){
            if(oldVal){
                this.itemModel.master_items = []
                this.itemModel.assets = []
            }
        },
        'itemModel.master_items': {
            handler(val, oldVal) {
                if(oldVal && oldVal.length > 0 && oldVal != val) {
                    this.itemModel.assets = []
                }
                if(val){
                    this.adjustMultiselectHeight('master_items_poi');
                }
                console.log('itemModel.master_items', val, oldVal)
            },
            deep: true
        },
        'itemModel.assets': {
            handler(val) {
                if(val){
                    this.adjustMultiselectHeight('assets_poi');
                }
            },
            deep: true
        }
    },
    async mounted() {
        await this.$store.commit('assets/SET', []);
        await this.$store.dispatch("itemType/fetchAll");
        // // Note: adding settimeout because loadCustomerAssets fn in ViewOrder.vue is being called after 500ms timeout.
        // setTimeout(() => {
        //     this.$store.dispatch("assets/fetchSchedule");
        // }, 600); 
        await this.$nextTick();
    },
    methods: {
        cancel() {
            this.itemModel = {...defaultItemModel}
            this.items = [];
            this.isViewItemModalVisible = false
            this.isListItemModalVisible = false
            this.$emit('cancel')
        },
        showItem(item, { viewMode }) {
            console.log('showItem item before', item)
            this.viewMode = viewMode;
            this.isViewItemModalVisible = true

           
            this.itemModel = {
                ...defaultItemModel,
                order_id: item.id,
            }
            console.log('showItem after itemModel', this.itemModel)

            //////////////////
            // const section_to_id = this.itemModel.section_to_id || this.orderModel.delivery_location_section_id
            // this.$set(this.itemModel, 'section_to_id', section_to_id)
            // this.masterItem = this.$store.state.masterItem
        },

        async searchMasterItem(query) {
            try {
                console.log('query', query)
                this.loading = true;
                const { order_item_type_id } = this.itemModel;

                if (query != "" && query.length < 3) return;
                if (order_item_type_id) {
                    await this.$store.dispatch("masterItem/fetchAll", {filters: {order_item_type_id}, query});
                } else {
                    this.itemModel.master_items = []
                }
            } catch (error) {
                console.error('error fetching master items', error)
            } finally {
                this.loading = false
            }
        },

        async searchAsset(query) {
            try {
                console.log('asset query', query)
                let { master_items } = this.itemModel;
                
                if (master_items && master_items.length > 0) {
                    this.loading = true;
                    master_items = master_items.map(x => x.id).join(',');
                    await this.$store.dispatch("assets/fetchSchedule", {filters: {master_items}, query});
                } else {
                    this.itemModel.master_items = []
                }
            } catch (error) {
                console.error('error fetching master items', error)
            } finally {
                this.loading = false
            }
        },

        clearAllAssets () {
            this.itemModel.assets = []
        },

        clearAllMasterItems () {
            this.itemModel.master_items = []
        },

        async listItem(order) {
            try {
                if(!order) return;
                this.isListItemModalVisible = true
                this.loading = true;

                let filters = {
                    order_id: order.id
                };

                this.itemModel = {
                    ...defaultItemModel,
                    order_id: order.id,
                }
                let results = await axios.get('order/products-of-interest/fetchAll?'+ buildQuery(filters));

                this.items = results.data.success.data;
            } catch(error) {
                console.error('products-of-interest/fetchAll error:', error);
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.loading = false;
            } 
        },

        viewItem(id) {
            let item = this.items.find(x => id == x.id)
            if(item){
                this.itemModel = item;
                this.isListItemModalVisible = false;
                this.isViewItemModalVisible = true;
                console.log('item---', item, this.items);
                this.adjustMultiselectHeight('master_items_poi');
                this.adjustMultiselectHeight('assets_poi');
            }
        }, 

        async createOrUpdate(){
            console.log('this.createOrUpdate', this.itemModel)

            try {
                this.loading = true
                const { itemModel } = this
                
                const path = itemModel.id ? 'order/products-of-interest/update' : 'order/products-of-interest/create'
                const message = itemModel.id ? this.$translate('updated') : this.$translate('created')
                
                let valid = await this.$validator.validate();
                if(valid) {
                    await axios.post(path, itemModel)
                    this.$emit('success', message)
                }
                this.isViewItemModalVisible = false

                this.doToast(
                    this.$translate('success'),
                    `${this.$translate('products_of_interest')} ${message}`,
                    'success'
                )
            } catch(error) {
                console.log("product of interest error", error.message)
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.loading = false
            }
        },

        async deleteItem(id) {
            try {
                this.loading = true
                let item = this.items.find(el => el.id == id)

                if(!item) throw new Error('Item not found');

                const title = `${this.$translate('delete')} ${this.$translate('products_of_interest')}`
                const message = `${this.$translate('delete_note')}?`
                
                const result = await this.confirmMessage(title, message)
                if (result) {
                    await axios.delete(`order/products-of-interest/delete/${id}`)

                    this.isViewItemModalVisible = false
                    this.isListItemModalVisible = false
                        
                    this.doToast(
                        this.$translate('deleted'),
                        `${this.$translate('products_of_interest')} ${this.$translate('delete_alert')}`,
                        'success'
                    )
                
                }
            } catch(error) {
                console.error(error)
                this.doToast(
                    this.$translate('error'),
                    error.message,
                    'danger'
                )
            } finally {
                this.loading = false
            }
        },

        adjustMultiselectHeight(class_name = '') {
        
            setTimeout(() => {
            
                if(class_name != ''){
                    const minHeight = 10;
                    const wrappersel = document.querySelector(`.${class_name} .multiselect__tags-wrap`);
                    // console.log('wrappersel', wrappersel)
                    if(!wrappersel) return;
                    const calculatedHeight = minHeight + wrappersel.offsetHeight;
                    // console.log('wrappersel.style.height', wrappersel.offsetHeight, calculatedHeight)
                
                    // const multiselectEl = document.querySelector('.multiselect');
                    const tagsel = document.querySelector(`.${class_name} .multiselect__tags`);
                    if (tagsel) {
                        // multiselectEl.style.height = `${calculatedHeight}px`;
                        tagsel.style.height =  `${calculatedHeight}px`;
                    }
                } else {
                    const minHeight = 10;
                    const wrappersel = document.querySelector('.multiselect__tags-wrap');
                    // console.log('wrappersel', wrappersel)
                    if(!wrappersel) return;
                    const calculatedHeight = minHeight + wrappersel.offsetHeight;
                    // console.log('wrappersel.style.height', wrappersel.offsetHeight, calculatedHeight)
                
                    // const multiselectEl = document.querySelector('.multiselect');
                    const tagsel = document.querySelector('.multiselect__tags');
                    if (tagsel) {
                        // multiselectEl.style.height = `${calculatedHeight}px`;
                        tagsel.style.height =  `${calculatedHeight}px`;
                    }
                }
            }, 200);
        }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags-wrap {
    display: inline-block;
    height: auto;
}
.multiselect__tags {
    height: auto !important;
}

.multiselect__clear {
    position: absolute;
    right: 41px;
    height: 40px;
    width: 40px;
    display: block;
    cursor: pointer;
    z-index: 3
}

.multiselect__clear:before,.multiselect__clear:after {
    content: "";
    display: block;
    position: absolute;
    width: 3px;
    height: 16px;
    background: #aaa;
    top: 12px;
    right: 4px
}

.multiselect__clear:before {
    transform: rotate(45deg)
}

.multiselect__clear:after {
    transform: rotate(-45deg)
}

</style>
